/**
 * Lightweight YouTube Video Modal Handler
 */
export const initVideoModal = () => {
	const triggers = document.querySelectorAll('.js-video-modal-trigger');

	if (triggers.length === 0) return;

	/**
	 * Extract YouTube ID from URL
	 */
	const getYouTubeId = (url: string) => {
		const regExp =
			/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
		const match = url.match(regExp);
		return match && match[2].length === 11 ? match[2] : null;
	};

	/**
	 * Create Modal UI
	 */
	const createModal = (videoId: string) => {
		const closeIconTemplate = document.getElementById(
			'js-video-modal-close-icon',
		) as HTMLTemplateElement;
		const closeIconHtml = closeIconTemplate
			? closeIconTemplate.innerHTML
			: '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';

		const overlay = document.createElement('div');
		overlay.className = 'video-modal-overlay js-video-modal-overlay';
		overlay.innerHTML = `
			<div class="video-modal-container js-video-modal-container">
				<button class="video-modal-close js-video-modal-close" aria-label="Fechar modal">
					${closeIconHtml}
				</button>
				<iframe
					class="video-modal-iframe"
					src="https://www.youtube.com/embed/${videoId}?autoplay=1"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen>
				</iframe>
			</div>
		`;

		document.body.appendChild(overlay);

		// Animation frame to trigger transition
		setTimeout(() => overlay.classList.add('active'), 10);

		const closeModal = () => {
			overlay.classList.remove('active');
			setTimeout(() => overlay.remove(), 300);
			document.removeEventListener('keydown', handleEsc);
		};

		const handleEsc = (e: KeyboardEvent) => {
			if (e.key === 'Escape') closeModal();
		};

		overlay.addEventListener('click', (e) => {
			if (
				e.target === overlay ||
				(e.target as HTMLElement).closest('.js-video-modal-close')
			) {
				closeModal();
			}
		});

		document.addEventListener('keydown', handleEsc);
	};

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			const videoUrl = (trigger as HTMLElement).dataset.videoUrl;
			if (!videoUrl) return;

			const videoId = getYouTubeId(videoUrl);
			if (videoId) {
				createModal(videoId);
			} else {
				// console.error('Invalid YouTube URL:', videoUrl);
				// Fallback to behavior if it's a real link
				const link = trigger.getAttribute('href');
				if (link && link !== '#') {
					window.open(link, '_blank');
				}
			}
		});
	});
};
